import sharesTitlesStatus from 'modules/partners/pages/ShareTitleList/constants/sharesTitlesStatus';

type GetShareTitleWatermarkText = {
  status: string | undefined;
  isAdmin: boolean;
};

export const getShareTitleWatermarkText = ({
  status,
  isAdmin,
}: GetShareTitleWatermarkText): string => {
  const CANCELLED_STATUS = sharesTitlesStatus[2].value;

  if (status === CANCELLED_STATUS) {
    return 'TÍTULO CANCELADO';
  }
  if (!isAdmin) {
    return 'CARÁCTER INFORMATIVO';
  }

  return '';
};
